import { cn } from '../../lib/utils';

/**
 * Consistent premium card shell for worker/applicant dashboards.
 */
export function WorkerPremiumCardHeader({ title, description, action, icon: Icon }) {
  return (
    <div className="mb-4 flex flex-col items-start gap-3 sm:flex-row sm:justify-between">
      <div className="min-w-0 w-full">
        <div className="flex min-w-0 items-center gap-2">
          {Icon ? (
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary/10 ring-1 ring-primary/15">
              <Icon className="h-4 w-4 text-primary" />
            </span>
          ) : null}
          <h2 className="min-w-0 break-words font-heading text-lg font-bold text-[#17324D]">{title}</h2>
        </div>
        {description ? (
          <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{description}</p>
        ) : null}
      </div>
      {action ? <div className="w-full shrink-0 sm:w-auto">{action}</div> : null}
    </div>
  );
}

export default function WorkerPremiumCard({
  children,
  className,
  accent = 'teal',
  padding = 'p-4',
  ...props
}) {
  const accents = {
    teal: 'border-[#E4E8EB] shadow-[0_8px_30px_rgba(15,92,94,0.06)]',
    amber: 'border-amber-200/80 shadow-[0_8px_30px_rgba(217,119,6,0.08)]',
    blue: 'border-blue-200/80 shadow-[0_8px_30px_rgba(37,99,235,0.08)]',
    purple: 'border-purple-200/80 shadow-[0_8px_30px_rgba(124,58,237,0.08)]',
    emerald: 'border-emerald-200/80 shadow-[0_8px_30px_rgba(5,150,105,0.08)]',
  };

  return (
    <div
      className={cn(
        'rounded-2xl border bg-white/95 backdrop-blur-sm',
        accents[accent] || accents.teal,
        padding,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
